module.exports = __webpack_public_path__ + "media/packs/images/metrics/track-36c51397115f6f72e43a0227d4463b28.svg";